/**
 * JWT utilities for frontend — decode only (no verification, as JWT is already
 * validated by the backend before being issued to the client).
 */

export interface DecodedJwt {
  sub?: string;
  name?: string;
  email?: string;
  roles?: string[];
  tenantId?: string;
  activeRole?: string;
  allowedLotes?: string[];
  jti?: string;
  accessHours?: { start: string; end: string };
  preferences?: { language: string; theme?: 'light' | 'dark' };
  iat?: number;
  exp?: number;
}

/**
 * Decodes a JWT token to extract the payload (no signature verification).
 * Safe to use on the client side since the token was already verified by the backend.
 */
export function decodeJwt(token: string): DecodedJwt | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    // Decode base64url to string (browser compatible)
    const payload = parts[1];
    const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4);
    const decoded = JSON.parse(atob(padded));
    return decoded as DecodedJwt;
  } catch {
    return null;
  }
}
